import { Page } from "@/components/layout/Page";
import { MaintenanceCard } from "@/components/maintenance/MaintenanceCard";
import { Container } from "@/components/ui/Container";

function MaintenancePage() {
  return (
    <Page className="flex items-center" title="Maintenance">
      <section className="w-full py-4 lg:py-6 xl:py-8">
        <Container>
          <MaintenanceCard />
        </Container>
      </section>
    </Page>
  );
}

export { MaintenancePage };
